export type EnvironmentVariables = {
  CENTRAL_DOMAIN: string[];
  API_URL: string;
  KEYCLOAK_JSON: any;
};

export const centralDomain = [
  "127.0.0.1",
  "localhost",
  "btoolsb.com",
  "qa.btoolsb.com",
  "dev.btoolsb.com",
];

export const builtinHostnameEnv: { [hostname: string]: EnvironmentVariables } =
  {
    "btoolsb.com": {
      CENTRAL_DOMAIN: centralDomain,
      API_URL: "https://btoolsb.com/api",
      KEYCLOAK_JSON: {
        realm: "btoolsb",
        "auth-server-url": "https://auth.btoolsb.com/",
        "ssl-required": "external",
        resource: "btoolsb-frontend",
        "public-client": true,
        "confidential-port": 0,
      },
    },
  };

export const defaultHostnameEnv: EnvironmentVariables = {
  CENTRAL_DOMAIN: centralDomain,
  API_URL: "http://tenantprandra.dev.btoolsb.com:8000/api",
  KEYCLOAK_JSON: {
    realm: "tenantprandra",
    "auth-server-url": "https://keycloak.dev.btoolsb.com/",
    "ssl-required": "external",
    resource: "btoolsb-frontend",
    "public-client": true,
    "confidential-port": 0,
  },
};

export const resolveEnvForHostname = (
  hostname: string,
  envMap: { [hostname: string]: EnvironmentVariables },
): EnvironmentVariables | undefined => {
  if (hostname in envMap) {
    return envMap[hostname];
  }

  if (hostname.startsWith("www.")) {
    const stripped = hostname.slice(4);
    if (stripped in envMap) {
      return envMap[stripped];
    }
  }

  if ("default" in envMap) {
    return envMap["default"];
  }

  return undefined;
};
